import styled from 'styled-components'

export const Html = styled.div`
  ${({ theme }) => theme.textStyles.firaSansTextBase}
  color: ${({ theme }) => theme.colors.arapawa};

  & p {
    &:not(:last-child) {
      padding-bottom: 1rem;
    }
  }

  & h1 {
    ${({ theme }) => theme.textStyles.firaSansTextBase}
  }
  & h2 {
    ${({ theme }) => theme.textStyles.firaSansTextBase}
  }
  & h3 {
    ${({ theme }) => theme.textStyles.firaSansTextBase}
  }
  & h4 {
    ${({ theme }) => theme.textStyles.firaSansTextBase}
  }
  & a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.ruby};
    &:hover {
      text-decoration: underline;
    }
  }
  & strong,
  & b {
    font-weight: bold;
    font-variation-settings: 'wggt' 700;
  }
`
